import { render, staticRenderFns } from "./InfoSysAndProg.vue?vue&type=template&id=474cb8ea&scoped=true&"
import script from "./InfoSysAndProg.vue?vue&type=script&lang=js&"
export * from "./InfoSysAndProg.vue?vue&type=script&lang=js&"
import style0 from "./InfoSysAndProg.vue?vue&type=style&index=0&id=474cb8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474cb8ea",
  null
  
)

export default component.exports